import { Form } from 'react-bootstrap';

const FolderGroupSelect = ({
  groups = [],
  value = '',
  onChange,
  placeholder = 'Selecionar pasta',
  isInvalid = false,
  disabled = false,
  required = false
}) => {
  const handleChange = e => {
    const selectedFolderId = e.target.value;
    if (onChange) {
      onChange(selectedFolderId);
    }
  };

  // Função para encontrar qual pasta está selecionada baseado no ID
  const getSelectedFolder = () => {
    if (!value) return null;

    for (const group of groups) {
      const folder = group.kbFolders?.find(
        folder => folder.id.toString() === value.toString()
      );
      if (folder) {
        return folder;
      }
    }
    return null;
  };

  return (
    <Form.Select
      value={value}
      onChange={handleChange}
      isInvalid={isInvalid}
      disabled={disabled}
      required={required}
    >
      <option value="">{placeholder}</option>

      {groups.map(group => (
        <optgroup key={group.id} label={group.name}>
          {group.kbFolders?.map(folder => (
            <option key={folder.id} value={folder.id}>
              {folder.name}
            </option>
          ))}
        </optgroup>
      ))}
    </Form.Select>
  );
};

export default FolderGroupSelect;
